import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white text-slate-900">
    <Header />
    <main className="flex-1" data-testid="site-main">
      {children}
    </main>
    <Footer />
    <Toaster richColors position="top-right" />
  </div>
);
